import { render, staticRenderFns } from "./Career.vue?vue&type=template&id=2c6f9f16&scoped=true"
var script = {}
import style0 from "./Career.vue?vue&type=style&index=0&id=2c6f9f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f9f16",
  null
  
)

export default component.exports